// Date helpers, ported verbatim from the original app.
export const MONTH_NAMES_FULL = ['Январь','Февраль','Март','Апрель','Май','Июнь','Июль','Август','Сентябрь','Октябрь','Ноябрь','Декабрь'];
export const MONTH_NAMES_SHORT = ['Янв','Фев','Мар','Апр','Май','Июн','Июл','Авг','Сен','Окт','Ноя','Дек'];
const MONTHS_GEN = ['янв','фев','мар','апр','май','июн','июл','авг','сен','окт','ноя','дек'];
const DAYS = ['Вс','Пн','Вт','Ср','Чт','Пт','Сб'];
export const DAYS_FULL = ['Воскресенье','Понедельник','Вторник','Среда','Четверг','Пятница','Суббота'];
// Editor/display order for a weekly plan (Mon..Sun) — indices into DAYS/DAYS_FULL, which
// are 0=Sunday-first (matching Date#getDay()) for everything else in this file.
export const WEEK_ORDER = [1, 2, 3, 4, 5, 6, 0];

export function today() { return new Date().toISOString().slice(0, 10); }

export function fmtDate(d) {
  const [y, m, day] = d.split('-');
  const dt = new Date(d + 'T12:00:00');
  return `${DAYS[dt.getDay()]}, ${+day} ${MONTHS_GEN[+m - 1]} ${y}`;
}

export function fmtDateShort(d) {
  const [y, m, day] = d.split('-');
  return `${+day} ${MONTHS_GEN[+m - 1]}`;
}

export function weekday(d) { return new Date(d + 'T12:00:00').getDay(); }
export function weekdayShort(d) { return DAYS[weekday(d)]; }

export function shiftDate(d, n) {
  const dt = new Date(d + 'T12:00:00');
  dt.setDate(dt.getDate() + n);
  return dt.toISOString().slice(0, 10);
}

export function monthLabel(ym) {
  const [y, m] = ym.split('-');
  return MONTH_NAMES_FULL[+m - 1] + ' ' + y;
}
